// extracted by mini-css-extract-plugin
export default {"container":"card_container__q8Y0A"};